import { apiConfig } from '@oneview/config';
import { isAdvisor, isProduction } from '@oneview/utils/branchUtils';
import { Middleware, Orbis } from '@orbis-systems/omni-sdk-ts';
import { AesMidasApi } from '@orbis-systems/orbis-api-clients/aesmidas';
import { MiddlewareApi } from '@orbis-systems/orbis-api-clients/middleware';
import { OrbisApi } from '@orbis-systems/orbis-api-clients/orbis';
import { UmaApi } from '@orbis-systems/orbis-api-clients/uma';
import { CacheLevel, OrbisApiMiddleware } from '@orbis-systems/orbis-api-middleware';

export const UMA_AUTH_STORAGE_KEY = 'auth:uma';

export function configureApi({
    onLoginTimeout,
}: {
    onLoginTimeout?: () => void;
} = {}) {
    const MIDAS_API_URL = `${apiConfig.umaApiUrl}/../../aes/api`;

    Orbis.storage.use('session');

    const orbisSdk = Orbis.connect({
        api_url: apiConfig.apiUrl,
        token_id: apiConfig.orbisToken,
        error_handling: false,
        onLoginTimeout,
    });

    const orbis = new OrbisApi({
        debug: !isProduction(),
        baseUrl: apiConfig.apiUrl,
        authDataStorageKey: 'auth:orbis',
        storage: sessionStorage,
        onLoginTimeout,
    });

    const middlewareSdk = Middleware.connect({
        api_url: apiConfig.middlewareUrl + '/v1',
        token_id: apiConfig.middlewareToken,
        error_handling: false,
    });

    const middleware = new MiddlewareApi({
        debug: !isProduction(),
        baseUrl: apiConfig.middlewareUrl,
        authDataStorageKey: 'auth:middleware',
        storage: sessionStorage,
    });

    const uma = new UmaApi({
        debug: !isProduction(),
        baseUrl: apiConfig.umaApiUrl,
        authDataStorageKey: UMA_AUTH_STORAGE_KEY,
        storage: sessionStorage,
        firmId: String(apiConfig.umaFirmId),
        authFormSlug: apiConfig.umaAuthFormSlug,
    });

    const aesmidas = new AesMidasApi({
        debug: !isProduction(),
        baseUrl: MIDAS_API_URL,
        authDataStorageKey: UMA_AUTH_STORAGE_KEY,
        storage: sessionStorage,
        onRenewToken: () => uma.renewToken(),
    });

    return {
        orbis,
        orbisSdk,
        middleware,
        middlewareSdk,
        orbisMiddleware: new OrbisApiMiddleware(
            {
                orbis,
                middleware,
            },
            {
                cacheLevel: CacheLevel.NoCache,
                apiPermissions: {
                    advisor: isAdvisor(),
                    rtbs: true,
                    iav: true,
                    documents: true,
                    transfers: true,
                    iavProcessorToken: true,
                },
            },
        ),
        uma,
        aesmidas,
    };
}

export type Api = ReturnType<typeof configureApi>;
